export const isClubsRedeemEnabled = process.env.ENABLE_CLUBS_REDEEM === 'true';
